<!--
 * @Descripttion: 
 * @Author: juanjuanhui
 * @Date: 2021-12-21 20:46:30
 * @LastEditors: yangsibo
 * @LastEditTime: 2022-12-29 20:29:58
-->
<template>
  <el-main>
    <div class="top-wrap">
      <Bread></Bread>
    </div>
    <div class="main">
      <div class="top-filter">
        <el-form
          ref="filterForm"
          :inline="true"
          :model="filterForm"
          class="filter-form"
        >
          <el-form-item prop="croplandVillGroup">
            <el-select
              v-model="filterForm.croplandVillGroup"
              placeholder="请选择村组"
              value-key="id"
              @change="handleChangeVillGroup"
            >
              <el-option label="全部" value="0"></el-option>
              <el-option
                v-for="item in villGroups"
                :key="item.id"
                :label="item.groupName"
                :value="item"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="croplandType">
            <el-select v-model="filterForm.croplandType" placeholder="土地属性">
              <el-option label="全部" value="0"></el-option>
              <el-option
                v-for="item in croplandTypeData"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleFilterMap">查询</el-button>
            <el-button
              type="primary"
              plain
              @click="handleResetFilter('filterForm')"
              ><i class="el-icon-refresh-right"></i>清空</el-button
            >
          </el-form-item>
        </el-form>
      </div>
      <div class="map-wrap">
        <div class="initial-btn" @click="initialAddress">
          <i class="iconfont icon-chushidingwei"></i>
        </div>
        <div class="map-div" id="mapDiv" ref="mapDiv"></div>
        <div class="map-top-info">
          <ul class="list">
            <li
              class="item"
              v-for="(item, index) in mapTopInfoOptions.data"
              :key="index"
            >
              <i class="block" :style="{ background: item.colour }"></i
              ><span>{{ item.name }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </el-main>
</template>

<script>
import TalksMap from "@/utils/initMapTalks.js";
export default {
  name: "LandResources",
  data() {
    return {
      filterForm: {
        croplandVillGroup: "", // 村组
        croplandType: "", // 土地属性
      },
      villGroups: [], // 所有的村小组
      croplandTypeData: [
        { id: 2, name: "耕地" },
        { id: 3, name: "园地" },
        { id: 4, name: "林地" },
        { id: 5, name: "草地" },
        { id: 6, name: "湿地" },
        { id: 7, name: "城镇村及工矿用地" },
        { id: 8, name: "交通运输用地" },
        { id: 9, name: "水域及水利设施用地" },
      ],
      TalksMapDialog: new TalksMap(),
      landList: [], // 所有的地块
      mapTopInfoOptions: {
        data: [
          { id: 2, name: "耕地", colour: "#985523" },
          { id: 3, name: "园地", colour: "#95de64" },
          { id: 4, name: "林地", colour: "#52c41a" },
          { id: 5, name: "草地", colour: "#03973e" },
          { id: 6, name: "湿地", colour: "#00bff6" },
          { id: 7, name: "城镇村及工矿用地", colour: "#e29e00" },
          { id: 8, name: "交通运输用地", colour: "#722ed1" },
          { id: 9, name: "水域及水利设施用地", colour: "#597ef7" },
        ],
      },
      curGroupInfo: {}, // 当前选择的村组信息
      dialogGroupVisible: false, // 去设置村组
      masterId: "",
      coordinate: [116.177427669, 28.861500052],
    };
  },
  watch: {
    landList: {
      handler: function (n) {
        if (this.landList.length > 0) {
          let lng, lat;
          let temp = JSON.parse(this.landList[0].centroid).coordinates;
          lng = temp[0];
          lat = temp[1];
          let Coordinate = {
            x: lng,
            y: lat,
          };
          this.coordinate = Coordinate;
        }
        this.TalksMapDialog.land(
          this.landList,
          "croplandEdge",
          "",
          true,
          true,
          this.landPolygonMouseenter
        );
      },
    },
  },
  computed: {
    dialogGroupChoiceClass() {
      let villGroups = this.villGroups,
        len = villGroups.length,
        className = "";
      if (len > 30) {
        className = "class2";
      } else if (len > 20) {
        className = "class2";
      } else if (len > 10) {
        className = "class2";
      } else {
        className = "class1";
      }
      return className;
    },
  },
  mounted() {
    this.masterId = this.$route.query.$businessAccountId;
    this.TalksMapDialog.sendThis(this);
    this.getMapInit();
    this.getVillGroups();
    this.getLandList();
  },
  methods: {
    /**
     * @Description:
     * @Author: yangsibo
     * @Date: 2022-12-29 09:12:20
     * @return {*}
     */
    initialAddress() {
      this.TalksMapDialog.map.setCenter(this.coordinate);
    },
    /**
     * @descripttion: 切换村小组
     * @Author: juanjuanhui
     * @Date: 2022-01-08 09:28:58
     * @param {*} item 当前数据项
     */
    handleChangeVillGroup(item) {
      this.curGroupInfo = item;
    },
    /**
     * @descripttion: 去设置村组
     * @Author: juanjuanhui
     * @Date: 2022-01-03 17:45:08
     */
    handleSetGroup() {
      this.$router.push({ path: "/system/organize" });
    },
    /**
     * @descripttion: 选择村组
     * @Author: juanjuanhui
     * @Date: 2022-01-03 17:41:37
     * @param {*} item
     */
    handleSelGroup(item) {
      this.curGroupInfo = item;
    },
    /**
     * @descripttion: 获取村小组数据
     * @Author: juanjuanhui
     * @Date: 2021-12-20 11:22:32
     */
    getVillGroups() {
      this.$http.common
        .getVillGroups({ masterId: this.masterId })
        .then((res) => {
          this.villGroups = res.data;
        });
    },
    /**
     * @descripttion: 获取地块信息
     * @Author: juanjuanhui
     * @Date: 2021-12-02 20:30:34
     */
    getLandList(params) {
      params = params ? params : {};
      params.accountId = this.masterId;
      this.$http.village.getLandList(params).then((res) => {
        this.landList = res.data;
      });
    },
    /**
     * @descripttion: 地图初始化
     * @Author: juanjuanhui
     * @Date: 2021-12-02 20:40:39
     */
    getMapInit() {
      this.TalksMapDialog.init("mapDiv", 16);
    },
    /**
     * @descripttion: 筛选地图
     * @Author: juanjuanhui
     * @Date: 2021-12-07 13:54:40
     */
    handleFilterMap() {
      let params = {
        croplandVillGroupId: this.filterForm.croplandVillGroup.id, // 村组
        croplandType: this.filterForm.croplandType,
      };
      this.getLandList(params);
    },
    /**
     * @descripttion: 重置筛选条件
     * @Author: juanjuanhui
     * @Date: 2021-12-14 10:40:34
     * @param {*} formName 表单ref名称
     */
    handleResetFilter(formName) {
      this.$refs[formName].resetFields();
      this.getLandList();
    },
    /**
     * @descripttion: 地图鼠标悬浮效果
     * @Author: juanjuanhui
     * @Date: 2022-01-20 21:06:20
     * @param {*} e
     */
    landPolygonMouseenter(e) {
      var options = {};
      this.$http.work.getLandDetail({ id: e.target.val.id }).then((res) => {
        let detail = res.data;
        options = {
          single: true,
          title: false,
          autoOpenOn: null, //单击地图时不打开窗口，则设置为null
          content: `<div class="map-info-box">
            <div class="msg-header">
              <p class="title">地块信息</p>
            </div>
            <div class="msg-body">
              <ul class="list">
                <li class="item">土地归属：${detail.croplandVillGroupName}</li>
                <li class="item">地块编号：${detail.croplandId}</li>
                <li class="item">土地属性：${detail.croplandTypeName}</li>
                <li class="item">地块面积：${detail.croplandArea}亩</li>
                <li class="item">地块周长：${detail.croplandPerimeter}米</li>
                <li class="item">位置描述：${
                  detail.address ? detail.address : ""
                }</li>
              </ul>
            </div>
          </div>`,
          autoPan: false, //弹窗边界不移动地图
          width: 300,
          custom: false,
        };
        e.target.setInfoWindow(options);
        e.target.openInfoWindow();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/common.scss";
.main {
  display: flex;
  flex-direction: column;
  .top-filter {
    display: flex;
    justify-content: space-between;
    .btn-panle {
      .el-button--warning {
        background-color: #f19149;
        border-color: #f19149;
        &:hover {
          background-color: #ebb563;
          border-color: #ebb563;
        }
      }
    }
  }
  .map-wrap {
    position: relative;
    flex: 1;
    .initial-btn {
      position: absolute;
      top: 67px;
      left: 15px;
      z-index: 1;
      cursor: pointer;
      width: 40px;
      height: 40px;
      background: #ffffff;
      border-radius: 5px;
      margin-right: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      .iconfont {
        color: #018388;
        font-size: 24px;
      }
    }
    .map-div {
      height: 100%;
    }
    .map-top-info {
      position: absolute;
      top: 0;
      left: 0;
      height: 52px;
      background-color: rgba($color: #000000, $alpha: 0.6);
      border-radius: 0px 0px 26px 0px;
      .list {
        display: flex;
        align-items: center;
        height: 100%;
        padding: 0 17px;
        .item {
          display: flex;
          align-items: center;
          position: relative;
          height: 100%;
          padding-left: 20px;
          margin-right: 22px;
          color: #fefeff;
          &.cursor {
            cursor: pointer;
          }
          &.active {
            .name {
              border-bottom: 3px solid #fff;
            }
          }
          .name {
            display: inline-flex;
            align-items: center;
            height: 100%;
          }
          .icon {
            margin-right: 5px;
          }
          .block {
            width: 16px;
            height: 16px;
            margin-right: 5px;
          }
        }
      }
    }
  }
}
::v-deep {
  .el-dialog {
    .el-dialog__footer {
      padding-top: 0;
      text-align: center;
    }
  }
  .dialog-group {
    .el-dialog__header {
      padding: 0;
    }
    .el-dialog__body {
      .info {
        padding-top: 20px;
        font-size: 20px;
        text-align: center;
        color: #444;
      }
    }
  }
  .dialog-group-choice {
    .el-dialog {
      // height: 80vh;
    }
    &.class1 {
      .el-dialog {
        width: 400px;
        .el-dialog__body {
          .list {
            .item {
              margin-right: 0;
            }
          }
        }
      }
    }
    &.class2 {
      .el-dialog {
        width: 770px;
        .el-dialog__body {
          .list {
            .item {
              margin-right: 10px;
              &:nth-child(2n) {
                margin-right: 0;
              }
            }
          }
        }
      }
    }

    .el-dialog__body {
      padding: 20px 20px 5px;
      .list {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        &:after {
          content: "";
          width: 350px;
        }
        .item {
          width: 350px;
          height: 40px;
          padding: 0 10px;
          margin: 0 0 15px 0;
          line-height: 40px;
          color: #222222;
          font-size: 16px;
          text-align: center;
          border-radius: 20px;
          border: solid 1px #d3d3d3;
          border-radius: 20px;
          box-sizing: border-box;
          cursor: pointer;
          &.active {
            color: #018388;
            background-color: #f7fefe;
            border: solid 1px #018388;
          }
        }
      }
    }
  }
}
</style>
